import React, { useEffect } from 'react';
import { Spin, Row, Col } from 'antd';
import cx from 'classnames';

import { UserRole } from 'enums';
import Accessor from 'components/Accessor';
import ActiveCustomersCard from './ActiveCustomersCard';
import { summaryDetailsLoadingSelector } from 'redux/selectors/homeDashboardSelectors';
import {
  getMyCustomers,
  getMyActiveAssignments,
  getTimesheetStatusReport,
  getAssignmentsEndingSoon,
} from 'redux/reducers/homeDashboardSlice';
import { getUserRoles } from 'utils/userRolesUtils';
import ActiveAssignmentsCard from './ActiveAssignmentsCard';
import TimesheetStatusReportCard from './TimesheetStatusReportCard';
import AssignmentsEndingSoonCard from './AssignmentsEndingSoonCard';
import { isCorporateTASelector } from 'redux/selectors/authenticationSelectors';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';

import styles from '../UserHomePage.module.less';

export default function SummarySection() {
  const dispatch = useAppDispatch();
  const isCorporateTA = useAppSelector(isCorporateTASelector);
  const isSectionLoading = useAppSelector(summaryDetailsLoadingSelector);

  useEffect(() => {
    !isCorporateTA && dispatch(getMyCustomers());
    dispatch(getMyActiveAssignments());
    dispatch(getTimesheetStatusReport());
    dispatch(getAssignmentsEndingSoon());
  }, [dispatch, isCorporateTA]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.pageTitle}>Dashboard</div>
      {isSectionLoading && <Spin />}
      {!isSectionLoading && (
        <Row gutter={[10, 10]}>
          <Accessor roles={getUserRoles(UserRole.RecruiterCompany)}>
            <Col xs={24} md={12} className="d-flex">
              <div className={styles.cardWrapper}>
                <ActiveCustomersCard />
              </div>
            </Col>
          </Accessor>

          <Col xs={24} md={12} className="d-flex">
            <div className={styles.cardWrapper}>
              <ActiveAssignmentsCard />
            </div>
          </Col>

          <Col xs={24} md={12} className="d-flex">
            <div className={cx(styles.cardWrapper, 'd-flex')}>
              <TimesheetStatusReportCard />
            </div>
          </Col>

          <Col xs={24} md={12} className="d-flex">
            <div className={styles.cardWrapper}>
              <AssignmentsEndingSoonCard />
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
}
